// Backlog query: last 4 days plus today (5 days total)
// Named as a constant to avoid recomputation and duplication across components
const _caseSummaryBacklogQuery = (() => {
  const toIsoDate = (d) => d.toISOString().slice(0, 10);
  const today = new Date();
  const start = new Date(today);
  start.setDate(today.getDate() - 4);
  return `Show me the case summary from ${toIsoDate(start)} to ${toIsoDate(today)}`;
})();

export const LOGIN = {
  WELCOME_MSG: "Welcome to MAERSK Next Gen Process Automation",
  MORE_INFO: "A Digital Assistant to assist you at every step",
  LOGIN_BUTTON_NAME: "Login to Digital Assistant",
};

export const DONUT_CHART_COLORS = {
  Open: "#d6e000", // light yellow
  Compliant: "#00685b", // dark green
  "Non Compliant": "#ffd029", // yellow
  Approved: "#24d5a6", // green
  Rejected: "#f9423a", // red
  Exception: "#806814", // dark yellow
  "On-Hold": "#f07508", // orange
  "Non AFR": "#f9423a", // red
  Reopened: "#d6e000", // purple
};

export const SUMMARY = {
  SUMMARY_HEADING: "Case Summary",
  SUMMARY_DETAILS:
    "Lorem ipsum dolor sit lorem a amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.",
  NO_SUMMARY: "You may request a message to display here,for example:",
  NO_RECORDS_FOUND: "No records found for the selected query. Please try a different search.",
};

export const CHAT_CONSTANTS = {
  CHAT_HEADING_NAME: "Digital Assistant",
  WELCOME_MESSAGE: "Hi, How may I help you",
  EXAMPLES: [
    // "Show all the pending cases till date",
    // "Show me the case summary for today",
    // "Show open cases till date", 
    // "Show me the compliant cases till date",
    // "Show me the non compliant cases till date",
    
    // "Show me the approved cases till date",
    // "Show me the rejected cases till date",
    // "Show me the AFR request cases for Customer..",
    // "Show me the AFR request Cases for Shipment No..",
    // "Show me the AFR request Cases for Invoice..",
    // "Show me the AFR request for Country .. from period .. to ..",
    // "Show me the AFR request for Region..  from period .. to ..",

    // "Fetch POP attribute .. from the POP.. for AFR Request.. ",
    // "List all cases between January 1, 2025, and January 21, 2025.",
    // "Show me the case details for 2409-244559980",
  ],
  PROMPT_CATEGORIES: [
    {
      title: "Summary",
      icon: "file-ribbon",
      color: "#42B0D5",      
      prompts: [
        {
          title: "Backlog Case Summary",
          description: "View backlog case summary",
          query: _caseSummaryBacklogQuery,
          icon: "bars-horizontal-bullets",
          color: "#141414",
          bgColor: "#E0F7FA",
          displayCount: false
        },
        {
          title: "Case Summary",
          description: "View case summary for last 6 days",
          query: "Show me the case summary for last 6 days",
          icon: "clipboard-text",
          color: "#141414",
          bgColor: "#E0F7FA",
          displayCount: true
        },
        {
          title: "Approved Cases",
          description: "View all approved cases",
          query: "Show me the approved cases till date",
          icon: "clipboard-check-text",
          color: "#141414",
          bgColor: "#B9E371",
          displayCount: true
        },
        {
          title: "Rejected Cases", 
          description: "View all rejected cases",
          query: "Show me the rejected cases till date",
          icon: "circle-slash",
          color: "#141414",
          bgColor: "#EA5D4B",
          displayCount: true
        },
 {
          title: "On-Hold Cases",
          description: "View all on-hold cases till date",
          query: "Show all on-hold cases till date",
          icon: "truck-front-clock",
          color: "#141414",
          bgColor: "#FED195",
          displayCount: true
        },
         {
          title: "Open Cases", 
          description: "View all open cases till date",
          query: "Show open cases till date",
          icon: "book-open",
          color: "#141414",
          bgColor: "#FFF5DD",
          displayCount: true
        }
      ]
    },
    // {
    //   title: "Case Overview",
    //   icon: "file-magnifying-glass",
    //   color: "#42B0D5",      
    //   prompts: [
    //     {
    //       title: "Pending Cases",
    //       description: "View all pending cases till date",
    //       query: "Show all pending cases till date",
    //       icon: "truck-front-clock",
    //       color: "#42B0D5"
    //     },
    //     {
    //       title: "Open Cases", 
    //       description: "View all open cases till date",
    //       query: "Show open cases till date",
    //       icon: "book-open",
    //       color: "#42B0D5"
    //     }
    //   ]
    // },
    {
      title: "Compliance",
      icon: "check-square-copy",
      color: "#42B0D5",
      prompts: [
        {
          title: "Compliant",
          description: "View all compliant cases",
          query: "Show me the compliant cases till date",
          icon: "check-circle",
          color: "#141414",
          bgColor: "#6CA926",
          displayCount: true
        },
        {
          title: "Non-compliant",
          description: "View all non-compliant cases", 
          query: "Show me the non compliant cases till date",
          icon: "exclamation-triangle-solid",
          color: "#141414",
          bgColor: "#FFD029",
          displayCount: true
        }
      ]
    },    
    {
      title: "Specific Case Details",
      icon: "file-eye",
      color: "#42B0D5",      
      prompts: [
        {
          title: "User Specific Cases",
          description: "View all AFR request cases for Customer specific requirements like region , country , invoice , date range etc",
          query: "Show me AFR request cases for Customer..",
          icon: "user-circle-solid",
          color: "#141414",
          bgColor: "#E0F7FA"
        },
        // {
        //   title: "Shipment No. Specific Cases", 
        //   description: "View all AFR request Cases for Shipment No..",
        //   query: "Show me AFR request Cases for Shipment No..",
        //   icon: "package",
        //   color: "#141414",
        //   bgColor: "#E0F7FA"
        // },
        // {
        //   title: "Invoice No. Specific Cases", 
        //   description: "View all AFR request Cases for Invoice..",
        //   query: "Show me AFR request Cases for Invoice..",
        //   icon: "receipt",
        //   color: "#141414",
        //   bgColor: "#E0F7FA"
        // },
        // {
        //   title: "Country Specific Cases", 
        //   description: "View all AFR request for Country .. from period .. to ..",
        //   query: "Show me AFR request for Country .. from period .. to ..",
        //   icon: "flag",
        //   color: "#141414",
        //   bgColor: "#E0F7FA"
        // },
        // {
        //   title: "Region Specific Cases", 
        //   description: "View all AFR request for Region..  from period .. to ..",
        //   query: "Show me AFR request for Region..  from period .. to ..",
        //   icon: "globe",
        //   color: "#141414",
        //   bgColor: "#E0F7FA"
        // }
      ]
    },
    {
      title: "Download Report",
      icon: "tray-arrow-down", // Appropriate icon for download
      color: "#1686BD", // Use a color consistent with your design
      prompts: [
        {
          title: "Download Report of All Closed AFR Cases",
          icon: "tray-arrow-down",
          color: "#1686BD",
          bgColor: "#E6F0FA", // Background color for the icon
          // description: "Generate and download a report of all closed AFR cases.",
          // query: "download_report_closed_afr_cases", // Unique query identifier for handling
        },
        {
          title: "Download Accuracy Report",
          icon: "file-eye",
          color: "#1686BD",
          bgColor: "#E6F0FA",
          // description: "Generate and download accuracy report across cases.",
        },
      ],
    },
    {
      title: "Validation Outcomes",
      icon: "folder-arrow-down", // Appropriate icon for download
      color: "#1686BD", // Use a color consistent with your design
      prompts: [
        {
          title: "Show me the validations carried out for #casenumber.",
          icon: "folder-arrow-down",
          color: "#1686BD",
          bgColor: "#E6F0FA", // Background color for the icon
          // description: "Generate and download a report of all closed AFR cases.",
          query: "Show me the validations carried out for #casenumber", // Unique query identifier for handling
        },
      ],
    },
  ]
};

export const MESSAGE_ACTION_TYPES = {
  ADD_MESSAGE: "ADD_MESSAGE",
  SET_MESSAGES: "SET_MESSAGES",
  UPDATE_MESSAGE: "UPDATE_MESSAGE",
};

export const DEFAULT_ROWS_PER_PAGE = 5;
export const ROWS_PER_PAGE_OPTIONS = [5, 10, 15];

export const statusColumns = ["casestatus", "outcome", "casestatusreason"];

export const defaultSummaryTableHeader = [
  "casenumber",
  "country",
  "blnumber",
  "casestatus",
  "sourcename",
  "caseassignedto",
  "casestatusreason",
   "email_subject",
  "modifiedby",
  // "modifieddate",
  "ie_modifieddate",
  "casetat",
  "slastatus",
  "dacaseprocessingtime",
  "slaremainingtime",
  "casereceiveddatetime",
  "casestatusdatetime",
  "countryslatime",
  "remarks",
];
export const validationOutcomeTableHeader = [
  "rulename",
  // "priority",
  "afrdata",
  "bookingdata",
  "outcome",
  "reason",
];

export const SLAstatusMap = {
  "SLA-MET": "SLA Met",
  "ON-HOLD": "On Hold",
};

export const CASE_DETAILS_CONSTANTS = {
  HEADERS: {
    ASSOCIATED_BL_NO: "Associated BL No. & Invoice Details",
    SUPPORTING_DOCUMENTS: "Supporting Documents",
    VALIDATION_OUTCOMES: "Validation Outcomes",
    MANUAL_VALIDATIONS_REVIEW: " Manual Validation Result",
  },
  MESSAGES: {
    NO_BL_NUMBERS_AVAILABLE:
      "No BL numbers or invoice details are available for this case.",
    NO_SUPPORTING_DOCUMENTS:
      "No supporting documents are available for this case.",
    NO_QUALIFIED_POP:
      "No Qualified POP for this case is present",
    NO_VALIDATION_OUTCOMES:
      "No validation outcomes are available for this case.",
    CASE_NOT_FOUND: "Case not found",
  },
  UNQUALIFIED_POP_DOCTYPE: "Unqualified-POP",
};

export const APPROVED_REJECTED_CASES = ["APPROVED", "REJECTED"];
